import { useState, useEffect } from "react";

export function useViewport() {
    const [viewport, setViewport] = useState({
        isMobile: window.innerWidth <= 768,
        isTablet: window.innerWidth > 768 && window.innerWidth <= 1024
    });

    useEffect(() => {
        const handleResize = () => {
            setViewport((prev) => {
                const newViewport = {
                    isMobile: window.innerWidth <= 768,
                    isTablet: window.innerWidth > 768 && window.innerWidth <= 1024
                };
                return JSON.stringify(prev) === JSON.stringify(newViewport) ? prev : newViewport;
            });
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return viewport;
}
